/** True when the data element is an API-backed select field. */
export const isApiFetchSelectElement = (element) => (
    element?.isFetchAPI === true && element?.type === 'select'
);

/** Cleared persisted value for API-backed select fields. */
export const getEmptyApiFetchSelectValue = () => null;

/** Returns true when the stored API select value has no selected member. */
export const isApiFetchSelectValueEmpty = (rawValue) => {
    if (rawValue == null || rawValue === '') {
        return true;
    }
    if (typeof rawValue === 'string') {
        return rawValue.trim() === '';
    }
    if (typeof rawValue === 'object') {
        const storedValue = rawValue.value;
        return storedValue == null || storedValue === '';
    }
    return false;
};

/**
 * Builds the blockState object saved for API-backed select fields.
 * @param {Object|null} selected - react-select selected option
 * @param {Object} element - field config
 */
export const buildApiFetchSelectBlockValue = (selected, element) => {
    if (!selected) {
        return null;
    }

    const valueField = element?.data?.valueField || 'name';
    const raw = selected.raw || selected;
    const storedValue = raw?.[valueField] ?? selected.value ?? '';
    const email = raw?.email ?? selected.email ?? '';

    return {
        value: storedValue == null ? '' : String(storedValue),
        email: email == null ? '' : String(email),
    };
};

/**
 * Maps blockState value to a react-select option for display.
 * @param {*} rawValue - value from blockState
 * @param {Object} element - field config
 */
export const parseApiFetchSelectDisplayValue = (rawValue, element) => {
    if (isApiFetchSelectValueEmpty(rawValue)) {
        return null;
    }

    if (typeof rawValue === 'string') {
        return {
            value: rawValue,
            label: rawValue,
            email: '',
        };
    }

    const displayValue = String(rawValue.value);
    return {
        value: displayValue,
        label: displayValue,
        email: rawValue.email == null ? '' : String(rawValue.email),
    };
};
